module.exports = __webpack_public_path__ + "static/media/halloween4.9a71d0b5.webp";